const ResourceExtensions = {
	images: ["png", "jpg", "jpeg", "gif"],
	diagrams: ["svg", "puml", "yaml", "mermaid"],
};

export default ResourceExtensions;
